export interface SerializedFile {
    name: string;
    type: string;
    data: string;
}

export function fileToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result as string); // returns data URL
        reader.onerror = reject;
        reader.readAsDataURL(file);
    });
}

export async function serializeFile(file: File): Promise<SerializedFile> {
   return {
       name: file.name,
       type: file.type,
       data: await fileToBase64(file),
   }
}

export function deserializeFile(file: SerializedFile) {
    const byteString = atob(file.data.split(',')[1] ?? file.data);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const uint8Array = new Uint8Array(arrayBuffer);

    for (let i = 0; i < byteString.length; i++) {
        uint8Array[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([arrayBuffer], { type: file.type });

    return new File([blob], file.name, { type: file.type });
}

